import {Component, OnInit} from '@angular/core';
import {NavigationService} from '../../../services/navigation.service';
import {PostMessageService} from '../../shared/services/post-message.service';
import { Router } from '@angular/router';
import { MetaService } from '../../shared/services/meta.service';

@Component({
  selector: 'app-notfound-page',
  templateUrl: './notfound-page.component.html',
  styleUrls: ['./notfound-page.component.scss']
})
export class NotfoundPageComponent implements OnInit {
  public isLanding: boolean = false;

  constructor(
      private _router: Router,
      private _navigationService: NavigationService,
      private _postMessageService: PostMessageService,
      private _metaService: MetaService
  ) { }

  ngOnInit(): void {
    this.isLanding = window.location.pathname.toLowerCase().includes("/landing");
    this._metaService.addMeta('robots', 'noindex, nofollow');
  }

  goToHomeRoute(): void {
    this._navigationService.getRedirectUrl('/').then(
        (resolved) => {
          if (resolved.isWidget) {
            // se sono in un widget, eseguo il redirect dall'esterno tramite postMessage
            // this._postMessageService.redirect(resolved.url);
            this._router.navigate([resolved.url]);
          } else {
            // ... altrimenti, effettuo direttamente il redirect tramite window.location.href
            window.location.href = resolved.url;
          }
        }
    );
  }

}
